import { sizer } from "layout/styles/styled/sizer";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";

import AIPromptEditor from "../../components/AIPromptEditor/AIPromptEditor";
import BaseRateFilesTable from "./components/BaseRateFilesTable";
import { CaseRateRulesTable } from "./components/CaseRateRulesTable";
import ConfigsTable from "./components/ConfigsTable";
import ContractsTable from "./components/ContractsTable";
import EdiConversionFilesTable from "./components/EdiConversionFilesTable";
import { InpatientRulesetsTable } from "./components/InpatientRulesetsTable";
import MarketPricesTable from "./components/MarketPricesTable";
import { PackagesTable } from "./components/PackagesTable";
import PayerRulesTable from "./components/PayerRulesTable";
import PayersTable from "./components/PayersTable";

const StyledButton = styled(Button)`
  gap: ${sizer(2)};
`;

const FlexWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: ${sizer(3)};
`;

export function PayerRules() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <TabView
      className="w-full"
      activeIndex={Number(searchParams.get("tab"))}
      onTabChange={(e) => setSearchParams({ tab: e.index.toString() })}
    >
      <TabPanel header="MPPR">
        <FlexWrapper>
          <StyledButton
            icon="pi pi-plus"
            className="p-button-raised"
            onClick={() => navigate("/payer-rules/mppr/new")}
          >
            New Payer Rule
          </StyledButton>
        </FlexWrapper>
        <PayerRulesTable />
      </TabPanel>
      <TabPanel header="Case Rate">
        <FlexWrapper>
          <StyledButton
            icon="pi pi-plus"
            className="p-button-raised"
            onClick={() => navigate("/payer-rules/case-rate/new")}
          >
            New Payer Rule
          </StyledButton>
        </FlexWrapper>
        <CaseRateRulesTable />
      </TabPanel>
      <TabPanel header="Packages">
        <FlexWrapper>
          <StyledButton
            icon="pi pi-plus"
            className="p-button-raised"
            onClick={() => navigate("/payer-rules/packages/new")}
          >
            New Package
          </StyledButton>
        </FlexWrapper>
        <PackagesTable />
      </TabPanel>
      <TabPanel header="Inpatient Rulesets">
        <FlexWrapper>
          <StyledButton
            icon="pi pi-plus"
            className="p-button-raised"
            onClick={() => navigate("/payer-rules/inpatient-rulesets/new")}
          >
            New Inpatient Ruleset
          </StyledButton>
        </FlexWrapper>
        <InpatientRulesetsTable />
      </TabPanel>
      <TabPanel header="Payers">
        <FlexWrapper>
          <StyledButton
            icon="pi pi-plus"
            className="p-button-raised"
            onClick={() => navigate("/payer-rules/payer/new")}
          >
            New Payer
          </StyledButton>
        </FlexWrapper>
        <PayersTable />
      </TabPanel>
      <TabPanel header="Base Rate Files">
        <BaseRateFilesTable />
      </TabPanel>
      <TabPanel header="Base Rate Configs">
        <ConfigsTable />
      </TabPanel>
      <TabPanel header="Contracts">
        <FlexWrapper>
          <StyledButton
            icon="pi pi-plus"
            className="p-button-raised"
            onClick={() => navigate("/payer-rules/contracts/new")}
          >
            New Contract
          </StyledButton>
        </FlexWrapper>
        <ContractsTable />
      </TabPanel>
      <TabPanel header="Market Price Datasets">
        <MarketPricesTable />
      </TabPanel>
      <TabPanel header="EDI Conversion Files">
        <EdiConversionFilesTable />
      </TabPanel>
      <TabPanel header="Prompt for AI Analysis">
        <AIPromptEditor />
      </TabPanel>
    </TabView>
  );
}
